import React from "react";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";

const useStyles = makeStyles(() => ({
  danger: {
    color: red[400],
    borderColor: red[400],
    "&:hover": {
      borderColor: red[300],
      backgroundColor: "rgba(239, 83, 80, 0.08)",
    },
  },
}));

// The one button style for actions on the order page: small, outlined, with
// an icon, so actions look like buttons and like each other. `tone` is
// "primary" (blue) for actions, "neutral" (grey) for cancel/toggle and
// "danger" (red) for destructive ones.
export const ActionButton = ({
  icon,
  endIcon,
  tone = "primary",
  children,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Button
      variant="outlined"
      size="small"
      color={tone === "primary" ? "primary" : "default"}
      className={tone === "danger" ? classes.danger : undefined}
      startIcon={icon}
      endIcon={endIcon}
      style={{ whiteSpace: "nowrap" }}
      {...rest}
    >
      {children}
    </Button>
  );
};

// Card or table title with its action (Edit, Add Charge…) right next to it, so
// it's clear what the action applies to. `spread` pushes the action to the far
// edge, for cards; tables keep it beside the title since search sits on the right.
// `adornment` sits right after the title text, e.g. a status chip.
const SectionTitle = ({ title, adornment, action, spread = false }) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent={spread ? "space-between" : "flex-start"}
    style={{ gap: 8 }}
  >
    <Box display="flex" alignItems="center" style={{ gap: 12 }}>
      <Typography component="h2" variant="h6">
        {title}
      </Typography>
      {adornment}
    </Box>
    {action}
  </Box>
);

export default SectionTitle;
